import React, { useState, useEffect } from "react";
import "./ExportModal.css";

function ExportModal({ isOpen, onClose, onExport, slides }) {
  const [selectedSlides, setSelectedSlides] = useState([]);
  const [exportType, setExportType] = useState("");

  useEffect(() => {
    if (slides) {
      setSelectedSlides(slides.map((s) => s.id));
    }
  }, [slides]);

  if (!isOpen) return null;

  const handleSlideSelection = (slideId) => {
    setSelectedSlides((prevSelected) => {
      if (prevSelected.includes(slideId)) {
        return prevSelected.filter((id) => id !== slideId);
      } else {
        return [...prevSelected, slideId];
      }
    });
  };

  const handleExport = () => {
    onExport(selectedSlides, exportType);
    onClose();
  };

  const handleSelectAll = () => {
    setSelectedSlides(slides.map((s) => s.id));
  };

  const handleDeselectAll = () => {
    setSelectedSlides([]);
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h1>Export</h1>
        
        <div className="export-options" >
          <div className="export-type">


                <div  style={{width: "100%"}}> 
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "16px" }}>
                    <img src="../../icons/linear-dark-logo.svg" alt="Linear App" style={{ padding: "2px", backgroundColor: "#fff", borderRadius: "4px", width: '24px', height: '24px', marginTop: '-8px' }} />
                    <p style={{letterSpacing: "1px", fontSize: "12px", color: "var(--Grey5)"}}>LINEAR</p>
                  </div>

                  <div className={exportType === "Linear Document" ? "export-label active" : "export-label"} onClick={() => setExportType("Linear Document")}>
                    <input
                      type="radio"
                      name="exportType"
                      value="Linear Document"
                      checked={exportType === "Linear Document"}
                      onChange={(e) => setExportType(e.target.value)}
                    />
                    <span className="custom-radio"></span>
                    Document
                  </div>


                  <div className={exportType === "Linear Tickets" ? "export-label active" : "export-label"} onClick={() => setExportType("Linear Tickets")}>
                    <input
                      type="radio"
                      name="exportType"
                      value="Linear Tickets"
                      checked={exportType === "Linear Tickets"}
                      onChange={(e) => setExportType(e.target.value)}
                    />
                    <span className="custom-radio"></span>
                    Issues
                  </div>

                </div>


                <div style={{width: "100%", marginBottom: "20px"}}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "16px" }}>
                    <img src="../../icons/google-tile.svg" alt="Google Sheets" style={{ padding: "2px", backgroundColor: "#fff", borderRadius: "4px", width: '24px', height: '24px', marginTop: '-8px' }} />
                    <p style={{letterSpacing: "1px", fontSize: "12px", color: "var(--Grey5)"}}>GOOGLE</p>
                  </div>

                  <div className={exportType === "Google Docs" ? "export-label active" : "export-label"} onClick={() => setExportType("Google Docs")}>
                    <input
                      type="radio"
                      name="exportType"
                      value="Google Docs"
                      checked={exportType === "Google Docs"}
                      onChange={(e) => setExportType(e.target.value)}
                    />
                    <span className="custom-radio"></span>
                    G Doc
                  </div>
                   
                   <div className={exportType === "Google Slides" ? "export-label active" : "export-label"} onClick={() => setExportType("Google Slides")}>
                    <input
                      type="radio"
                      name="exportType"
                      value="Google Slides"
                      checked={exportType === "Google Slides"}
                      onChange={(e) => setExportType(e.target.value)}
                    />
                    <span className="custom-radio"></span>
                    G Slides
                  </div>

                </div>


                <div  style={{width: "100%"}}>
                  
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "16px" }}>
                    <img src="../../icons/atlassian-logo.svg" alt="Google Sheets" style={{ padding: "2px", backgroundColor: "#fff", borderRadius: "4px", width: '24px', height: '24px', marginTop: '-8px' }} />
                    <p style={{letterSpacing: "1px", fontSize: "12px", color: "var(--Grey5)"}}>ATLASSIAN</p>
                  </div>

                  <div className={exportType === "Confluence page" ? "export-label active" : "export-label"} onClick={() => setExportType("Confluence page")}>
                    <input
                      type="radio"
                      name="exportType"
                      value="Confluence page"
                      checked={exportType === "Confluence page"}
                      onChange={(e) => setExportType(e.target.value)}
                    />
                    <span className="custom-radio"></span>
                    Confluence page
                  </div>
                  <div className={exportType === "JIRA tickets" ? "export-label active" : "export-label"} onClick={() => setExportType("JIRA tickets")}>
                    <input
                      type="radio"
                      name="exportType"
                      value="JIRA tickets"
                      checked={exportType === "JIRA tickets"}
                      onChange={(e) => setExportType(e.target.value)}
                    />
                    <span className="custom-radio"></span>
                    JIRA tickets
                  </div>
                </div>

          </div>

          <div className="slide-selection">
            <h3>Select Slides</h3>
            <div className="select-buttons">
                <button onClick={handleSelectAll}>Select All</button>
                <button onClick={handleDeselectAll}>Deselect All</button>
            </div>
            <div className="slides-list">
              {slides && slides.map((slide, index) => (
                <button
                  key={slide.id}
                  onClick={() => handleSlideSelection(slide.id)}
                  className={`btn ${selectedSlides.includes(slide.id) ? "active" : ""}`}
                >
                  Board {index + 1}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="modal-buttons">
          <button onClick={onClose} className="btn">
            Cancel
          </button>
          <button onClick={handleExport} className="build-element">
            Export
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExportModal;
